import { Grid } from "@mui/material";
import { ReportDialogWrapperProps } from "../../../interfaces";
import { AdjustEndDateDialog } from "./dialogs/AdjustEndDateDialog";

import { AdminBookingReportVO } from "../../../types/model/valueObject/booking/AdminBookingReportVO";
import { CancelBookingDialog } from "./dialogs/CancelBookingDialog";
import { ToggleChargeOveragesDialog } from "./dialogs/ToggleChargeOveragesDialog";
import { SetToManualPaymentDialog } from "./dialogs/SetToManualPaymentDialog";
import { EndBookingDialog } from "./dialogs/EndBookingDialog";
import { CreateNextInvoiceDialog } from "./dialogs/CreateNextInvoiceDialog";

export const dialogs = Object.freeze({
  ADJUST_END_DATE: "ADJUST_END_DATE",
  CANCEL_BOOKING: "CANCEL_BOOKING",
  TOGGLE_CHARGE_OVERAGES: "TOGGLE_CHARGE_OVERAGES",
  SET_TO_MANUAL_PAYMENT: "SET_TO_MANUAL_PAYMENT",
  END_BOOKING: "END_BOOKING",
  CREATE_NEXT_INVOICE: "CREATE_NEXT_INVOICE",
});

const AdminBookingDialogWrapper = ({
  dialog,
  onClose
}: ReportDialogWrapperProps<AdminBookingReportVO>) => {

  const isOpen = (dialogType: string) => {
    return dialog?.dialog === dialogType && Boolean(dialog?.item)
  }

  return <Grid>
    <AdjustEndDateDialog
      open={isOpen(dialogs.ADJUST_END_DATE)}
      item={dialog?.item}
      onClose={onClose}
    />
    <CancelBookingDialog
      item={dialog?.item}
      open={isOpen(dialogs.CANCEL_BOOKING)}
      onClose={onClose}
    />
    <ToggleChargeOveragesDialog
      item={dialog?.item}
      open={isOpen(dialogs.TOGGLE_CHARGE_OVERAGES)}
      onClose={onClose}
    />
    <SetToManualPaymentDialog
      item={dialog?.item}
      open={isOpen(dialogs.SET_TO_MANUAL_PAYMENT)}
      onClose={onClose}
    />
    <EndBookingDialog
      item={dialog?.item}
      open={isOpen(dialogs.END_BOOKING)}
      onClose={onClose}
    />
    <CreateNextInvoiceDialog
      item={dialog?.item}
      open={isOpen(dialogs.CREATE_NEXT_INVOICE)}
      onClose={onClose}
    />
  </Grid>
}

export { AdminBookingDialogWrapper };
